"use client";

/* istanbul ignore file */
import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import type { CreateWaveStep } from "@/types/waves.types";
import CreateWaveFlow from "./CreateWaveFlow";
import CreateWaveLayout from "./CreateWaveLayout";
import CreateWaveStepContent from "./CreateWaveStepContent";
import type { CreateWaveDescriptionHandles } from "./description/CreateWaveDescription";
import { useCreateWaveSubmission } from "./hooks/useCreateWaveSubmission";
import { useWaveConfig } from "./hooks/useWaveConfig";
export default function CreateWave(t0) {
  const $ = _c(24);
  const {
    profile,
    onBack,
    onSuccess
  } = t0;
  const waveConfig = useWaveConfig();
  const {
    config,
    step,
    selectedOutcomeType,
    onStep
  } = waveConfig;
  const descriptionRef = useRef(null);
  let t1;
  if ($[0] !== config || $[1] !== onSuccess) {
    t1 = {
      config,
      descriptionRef,
      onSuccess
    };
    $[0] = config;
    $[1] = onSuccess;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    submitting,
    showDropError,
    onHaveDropToSubmitChange,
    onInlineGroupCreate,
    onComplete
  } = useCreateWaveSubmission(t1);
  let t2;
  if ($[3] !== onStep) {
    t2 = (targetStep, direction) => {
      onStep({
        step: targetStep,
        direction
      });
    };
    $[3] = onStep;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const setStep = t2;
  const t3 = `Create Wave ${config.overview.name ? `"${config.overview.name}"` : ""}`;
  const t4 = selectedOutcomeType === null;
  let t5;
  if ($[5] !== onHaveDropToSubmitChange || $[6] !== onInlineGroupCreate || $[7] !== profile || $[8] !== showDropError || $[9] !== submitting || $[10] !== waveConfig) {
    t5 = <CreateWaveStepContent controller={waveConfig} profile={profile} descriptionRef={descriptionRef} submitting={submitting} showDropError={showDropError} onHaveDropToSubmitChange={onHaveDropToSubmitChange} onInlineGroupCreate={onInlineGroupCreate} />;
    $[5] = onHaveDropToSubmitChange;
    $[6] = onInlineGroupCreate;
    $[7] = profile;
    $[8] = showDropError;
    $[9] = submitting;
    $[10] = waveConfig;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== config || $[13] !== onComplete || $[14] !== setStep || $[15] !== step || $[16] !== submitting || $[17] !== t4 || $[18] !== t5) {
    t6 = <CreateWaveLayout config={config} step={step} showActions={t4} submitting={submitting} setStep={setStep} onComplete={onComplete}>{t5}</CreateWaveLayout>;
    $[12] = config;
    $[13] = onComplete;
    $[14] = setStep;
    $[15] = step;
    $[16] = submitting;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== onBack || $[21] !== t3 || $[22] !== t6) {
    t7 = <CreateWaveFlow title={t3} onBack={onBack}>{t6}</CreateWaveFlow>;
    $[20] = onBack;
    $[21] = t3;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
}